import {
    SwiperCarouselPortraitBreakpoints,
    SwiperCarouselLandsCapeBreakpoints,
} from 'components/settings/BreakpointSettings';
import HighlightCarousel from './HighlightCarousel';
import chExpandedTpl from 'templates/carousels/highlightCarousel/expandingContainer.tpl';
import { calculatePosition } from '../helpers';
import { trackAction } from 'helpers/trackingOM';
import Breakpoints from 'helpers/breakpoints';
import MediaManager from 'components/highlight/MediaManager';

export class ContentHighlightCarousel extends HighlightCarousel {
    bp = new Breakpoints();
    constructor(element, options) {
        super(element, options);
        this.type = 'ch';
        this.template = chExpandedTpl;
    }

    // desgin spec is 150% of 16:9 thumbnail, to get size of thumbnail we calculated the ratio thumbnail:window using KW carousel at each breakpoint
    // then to calculate we multiply window width by this number to get size of 16:9 thumbnail
    static thumbnailToWindowRatio = new Map([
        ['desktopWide', 0.144],
        ['desktop', 0.167],
        ['tabletLandscape', 0.22],
        ['tabletPortrait', 0.28],
    ]);

    __preloadImage(elementData) {
        const url = elementData.poster;
        if (url) {
            new Image().src = url;
        }
    }

    __expandElement(carouselElement, expandedElement) {
        // design width spec is 1.5x the 16:9 thumbnail at each breakpoint
        const growthRate = 1.5;
        // 48 is margins around bottom component (24px each side)
        const expandedWidth =
            ContentHighlightCarousel.thumbnailToWindowRatio.get(
                this.bp.getCurrentBreakpointName(),
            ) *
                window.innerWidth *
                growthRate +
            48;

        expandedElement.style.display = 'block';

        let positionObj = calculatePosition(
            carouselElement,
            expandedWidth,
            expandedWidth,
            this.expandedElement,
        );
        Object.assign(expandedElement.style, positionObj);

        expandedElement.style.width = `${expandedWidth}px`;
        expandedElement.style.height = `auto`;
        expandedElement.style.opacity = 1;

        // 48 is padding around bottom components (24 each side)
        expandedElement.querySelector(
            '.ch-expanded-overlay-components',
        ).firstElementChild.style.width = `${expandedWidth - 48}px`;
        // set min height so container fills the space while image loads, inverse aspect ratio * width = height
        expandedElement.querySelector('.media-manager-container').style.minHeight =
            (1 / 1.78) * expandedWidth + 'px';

        trackAction(
            'trackCarouselTileInFocus',
            this.__getTrackingSpecs(carouselElement, expandedElement),
        );

        setTimeout(() => {
            if (this.expandedElement) {
                this.expandedElement.querySelector(
                    '.ch-expanded-overlay-components',
                ).style.opacity = 1;
            }
        }, 200);

        expandedElement.addEventListener('mouseleave', () => {
            this.__removeExpandedElement(carouselElement);
        });
    }

    __createMediaManager(data, target) {
        let carouselId = this.element?.closest('.carousel')?.getAttribute('data-displayId');
        carouselId = carouselId ?? '';
        const previewContainer = `ch_${carouselId}_${data.videoContentId}`;
        const isChannel = data.isLive || data.isUpcomingListing;
        const channelName = data.multiChannelName ?? data.channelName ?? '';
        const mediaManagerOptions = {
            target,
            channelName: isChannel ? channelName : null,
            videoLogoUrl: data.logo,
            imageUrl: data.poster,
            fallbackText: data.titleText,
            altImage: data.alt,
            videoContentId: data.videoContentId,
            isLive: data.isLive,
            isUpcoming: data.isUpcomingListing,
            scheduleBadge: data.scheduleBadge,
            scheduleBadgeText: data.scheduleBadgeText,
            isEvent: data.isEvent,
            hlsVideoUrl: data.videoPreviewURL ?? '',
            previewContainer: `search_${data.videoContentId}`,
        };

        this.mediaManager = new MediaManager(mediaManagerOptions);
    }
}

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');
    let orientation = customOptions.orientation;
    let defaultOptions = {
        responsive:
            orientation === 'portrait'
                ? SwiperCarouselPortraitBreakpoints
                : SwiperCarouselLandsCapeBreakpoints,
        zoomCarouselEffectDisabled: true,
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);

    new ContentHighlightCarousel(wrapper, endOptions);
}
